/**
 * The typed columns one entry has, per family: migration 0002's slot columns
 * on data.entry. A leaf module, because the authoring (`compose-author.ts`)
 * and the template validator (`templates/validate-template.ts`) both read it,
 * and the validator cannot import the authoring.
 *
 *   n  numbers: money, number, quantity, a worked-out number
 *   t  text
 *   d  dates
 *   r  a choice or a reference (a select, a reference to a list)
 *   b  yes-or-no
 */
export const ENTRY_SLOT_COUNT = { n: 6, t: 6, d: 4, r: 6, b: 2 } as const satisfies Readonly<
  Record<'n' | 't' | 'd' | 'r' | 'b', number>
>;

export type EntrySlotLetter = keyof typeof ENTRY_SLOT_COUNT;

/**
 * Which families may spill into the attrs document when full. Text, a date
 * past the time axis, and a yes-or-no lose nothing there. A number does: no
 * total, sort or filter reads attrs, so a seventh money field is refused
 * rather than kept where nothing adds it up. A select or a reference holds a
 * real key, which the registry never allows in a document, and a formula's
 * whole reason for keeping its answer is that a slot can be read.
 */
export const ENTRY_SLOT_SPILLS = ['t', 'd', 'b'] as const satisfies readonly EntrySlotLetter[];
